import { connect } from 'react-redux';
import { OAuthConfirm } from './oauth-confirmation-modal.component';

const mapStateToProps = ({ lang }) => ({
  lang: lang.OAUTH_CONFIRMATION,
});

export default connect(mapStateToProps)(OAuthConfirm);
